import req from "../../../services/psikotest/request";

class ResilienceDistraction {
  async list() {
    try {
      const res = await req.get("/api/psikotest_system/resilience_distraction/");
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async create(data: TPSResilienceDistraction) {
    try {
      const res = await req.post("/api/psikotest_system/resilience_distraction/", data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async update(id: number, data: TPSResilienceDistraction) {
    try {
      const res = await req.put("/api/psikotest_system/resilience_distraction/" + id, data);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  async delete(id: number) {
    try {
      const res = await req.delete("/api/psikotest_system/resilience_distraction/" + id);
      return res;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export default ResilienceDistraction;
